module.exports = __webpack_public_path__ + "img/undraw_Checklist__re_2w7v.51917332.svg";